import styles from "./GraphControls.module.css";

export interface GraphControlsProps {
  depth: number;
  maxDepth: number;
  onDepthChange: (depth: number) => void;
  varianceOnly: boolean;
  onVarianceOnlyChange: (value: boolean) => void;
  showMinimap: boolean;
  onShowMinimapChange: (value: boolean) => void;
  onFitView: () => void;
}

export function GraphControls({
  depth,
  maxDepth,
  onDepthChange,
  varianceOnly,
  onVarianceOnlyChange,
  showMinimap,
  onShowMinimapChange,
  onFitView,
}: GraphControlsProps) {
  const sliderMax = Math.min(20, maxDepth);

  return (
    <div className={styles.toolbar} role="toolbar" aria-label="Graph controls">
      <label className={styles.control}>
        <span className={styles.controlLabel}>Depth: {depth}</span>
        <input
          type="range"
          min={1}
          max={sliderMax}
          value={Math.min(depth, sliderMax)}
          onChange={(e) => onDepthChange(Number(e.target.value))}
          className={styles.slider}
        />
      </label>

      <label className={styles.control}>
        <input
          type="checkbox"
          checked={varianceOnly}
          onChange={(e) => onVarianceOnlyChange(e.target.checked)}
        />
        <span className={styles.controlLabel}>Variance path only</span>
      </label>

      <label className={styles.control}>
        <input
          type="checkbox"
          checked={showMinimap}
          onChange={(e) => onShowMinimapChange(e.target.checked)}
        />
        <span className={styles.controlLabel}>Minimap</span>
      </label>

      <button type="button" className={styles.button} onClick={onFitView}>
        Fit to View
      </button>
    </div>
  );
}
